import { ProductExperienceApi } from '../../models/product/product.api';
import { CommerceApiHttpService, CommerceApiProductContext } from '../../common/types';
import { ExtendedSMSProduct, SMSPointOfService, SMSProduct } from '../../models/shared/ocb';
import { createProductDetail } from '../../mappers/ocb/product.mapper';
import { ProductDetail } from '../../models/product';

export class BffOcbProductExperienceApi implements ProductExperienceApi {
  constructor(
    private http: CommerceApiHttpService,
    private i18n: CommerceApiProductContext['i18n'],
    private mapVehicleModel: (data: SMSProduct) => ExtendedSMSProduct,
  ) {}

  public async getProduct(productCode: string): Promise<ProductDetail> {
    const { data: bffProduct } = await this.http.get<ExtendedSMSProduct>(`${productCode}`, {
      params: {
        fields: 'FULL',
      },
    });

    const product = createProductDetail(bffProduct, { i18n: this.i18n });

    product.vendor = { pointOfServices: product.pointOfServices as Required<SMSPointOfService>[] };

    // TODO: This is a temp solution in order to pass expected model by aem lead form. See details in ticket DMHB-2142
    bffProduct.pointOfServices = product.pointOfServices;
    product.__originalVehicleModel = this.mapVehicleModel(bffProduct);

    return product;
  }
}
